import { render, staticRenderFns } from "./DuplicidadeDePaciente.vue?vue&type=template&id=20698819&"
import script from "./DuplicidadeDePaciente.vue?vue&type=script&lang=js&"
export * from "./DuplicidadeDePaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports